import Modal, { ModalBody, ModalFooter, ModalHeader, Prompt } from '@ingka/modal';
import Button from '@ingka/button';
import { useTranslation } from 'react-i18next';
import Text from '@ingka/text';
import React, { useState } from 'react';
import QuantityStepper from '@ingka/quantity-stepper';
import styles from './AddWinnersModal.module.scss';

export type AddWinnersModalProps = {
  visible: boolean;
  onClose: () => void;
  onConfirm: (count: number) => void;
};

export const AddWinnersModal: React.FC<AddWinnersModalProps> = ({
  visible,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const [numberOfNewWinners, setNumberOfNewWinners] = useState(0);

  return (
    <Modal visible={visible} handleCloseBtn={onClose}>
      <Prompt
        aria-labelledby={t('add-winners-modal-title')}
        title={t('add-winners-modal-title')}
        titleId={t('add-winners-modal-title')}
        header={<ModalHeader ariaCloseTxt={`${t('general-close-prompt')}`} />}
        footer={
          <ModalFooter>
            <Button text={`${t('general-cancel')}`} type="secondary" onClick={onClose} />
            <Button
              text={`${t('add-winners-modal-title')}`}
              type="primary"
              disabled={numberOfNewWinners === 0}
              onClick={() => onConfirm(numberOfNewWinners)}
            />
          </ModalFooter>
        }
      >
        <ModalBody className={styles['modal-body']}>
          <Text className={styles['body-text']}>{t('add-winners-modal-text')}</Text>

          <QuantityStepper
            className={styles['quantity-stepper']}
            small
            ariaDescribedBy={t('add-winners-modal-quantity-stepper-aria-label')}
            ariaDescribedById="helper"
            defaultValue={0}
            maxVal={10}
            minVal={0}
            onQuantityChange={(value) => setNumberOfNewWinners(value)}
          />
        </ModalBody>
      </Prompt>
    </Modal>
  );
};
